module.exports = "/images/vendor/flag-icon-css/flags/4x3/sc.svg?e6584421fdc8b72dfd9e2a139b71e82a";